export const pricingTiers = [
    {
        name: "Standard",
        href: "/sign-up",
        priceMonthly: 79,
        description: "Our Standard plan is perfect for individuals and small businesses looking to kickstart their Instagram growth journey. With authenticity and manual interaction, we ensure that your account receives the attention it deserves.",
    },
    {
        name: "Premium",
        href: "/sign-up",
        priceMonthly: 149,
        description: "Our Premium plan takes your Instagram growth to the next level, catering to influencers, businesses, and brands seeking accelerated growth and increased engagement.",
    },
    {
        name: "Business",
        href: "/sign-up",
        priceMonthly: 349,
        description:
            "Our Business plan is designed for established brands and businesses looking to dominate their industry and reach new heights of influence on Instagram.",
    },
];